import { Box, Typography, useTheme } from "@mui/material"
import { ReactElement } from "react"

interface IZeroDnoApplicationsMsgProps {
    escalatePage: boolean
}

/** Fallback text for when zero search results are returned in DNO queue */
const ZeroDnoApplicationsMsg = ({
    escalatePage,
}: IZeroDnoApplicationsMsgProps): ReactElement => {
    const theme = useTheme()
    return escalatePage ? (
        <Typography variant="h6" component="div">
            There are{" "}
            <Box color={theme.palette.primary.main} display="inline">
                no applications requiring your attention!
            </Box>{" "}
            Check the filter bar to ensure you have the correct filters selected
        </Typography>
    ) : (
        <Typography variant="h6" component="div">
            There are currently{" "}
            <Box color={theme.palette.primary.main} display="inline">
                no resolved applications
            </Box>{" "}
            at this time for the current filter selection
        </Typography>
    )
}

export default ZeroDnoApplicationsMsg
